import React, {Component} from 'react';
import './tela_video.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faPaperclip, faPhoneSlash, faMicrophoneSlash} from '@fortawesome/free-solid-svg-icons';
import {faEye, faEyeSlash} from '@fortawesome/free-regular-svg-icons'

export default class GridButtons extends Component{
    constructor(){
        super()
        this.state={muteMicrofone:false, muteAudio:false, desabilitaVideo:false}
        this.mutarMicrofone=this.mutarMicrofone.bind(this)
        this.mutarAudio=this.mutarAudio.bind(this)
        this.desabilitarVideo=this.desabilitarVideo.bind(this)
    }
    mutarMicrofone(){
        if (this.state.muteMicrofone==true)
            this.setState({muteMicrofone:false})
        else
            this.setState({muteMicrofone:true})   
    }
    mutarAudio(){
        if (this.state.muteAudio==true)
            this.setState({muteAudio:false})
        else
            this.setState({muteAudio:true})        
    }
    desabilitarVideo(){
        if (this.state.desabilitaVideo==true)
            this.setState({desabilitaVideo:false})
        else
            this.setState({desabilitaVideo:true})        
    }

    render(){
        return(

            <div className='grid-buttons'>
                { this.state.muteMicrofone ? <button onClick={this.mutarMicrofone} className='botao-video'><FontAwesomeIcon icon={faMicrophoneSlash} size='lg'/></button>
                    : <button onClick={this.mutarMicrofone} className='botao-video'><FontAwesomeIcon icon={faMicrophone} size='lg'/></button>}
                
                {this.state.muteAudio ?  <button onClick={this.mutarAudio} className='botao-video'><i className="material-icons">volume_off</i></button>
                : <button onClick={this.mutarAudio} className='botao-video'><i className="material-icons">volume_up</i></button>}

                {this.state.desabilitaVideo ? <button onClick={this.desabilitarVideo} className='botao-video'><FontAwesomeIcon icon={faEyeSlash} size='lg' /></button>
                : <button onClick={this.desabilitarVideo} className='botao-video'><FontAwesomeIcon icon={faEye} size='lg' /></button>}
                
                <button className='botao-video'><FontAwesomeIcon icon={faPaperclip} size='lg'/></button>
                <button style={{backgroundColor:'#F52934'}} className='botao-video'><FontAwesomeIcon icon={faPhoneSlash} size='lg'/></button>
            </div>
        )
    }
}